import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OutsourcedUserFteItem from '../../../Domain/OutsourcedUserFte/OutsourcedUserFteItem';
import OutsourcedUserFteService from '../../../Services/OutsourcedUserFte/OutsourcedUserFteService';
import { toDateOnlyString } from '../../../Domain/OutsourcedUserFte/outsourcedUserFteHelpers';

export default class EditOutsourcedUserFteWindowDescription {
  static titleForCreate = 'Add FTE Entry';
  static titleForEdit = 'Edit FTE Entry';
  static itemType = OutsourcedUserFteItem;
  static serviceFunction = (item) => {
    const payload = {
      ...item,
      StartDateUtc: toDateOnlyString(item.StartDateUtc),
      EndDateUtc: toDateOnlyString(item.EndDateUtc),
    };
    return payload.OutsourcedUserFteid
      ? OutsourcedUserFteService.Update(payload)
      : OutsourcedUserFteService.Create(payload);
  };

  static pagesInGeneralEditWizzard = [
    {
      label: 'FTE Details',
      fields: [
        {
          fieldName: 'HiringOfficeId',
          label: 'Hiring Office *',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forDifferentFieldworkAndHiringOffice,
        },
        {
          fieldName: 'FieldworkOfficeId',
          label: 'Fieldwork Office *',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forDifferentFieldworkAndHiringOffice,
          idFilter: 'HiringOfficeId',
        },
        {
          fieldName: 'Ftepercentage',
          label: 'FTE Percentage *',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'StartDateUtc',
          label: 'Start Date *',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'EndDateUtc',
          label: 'End Date *',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forFteEndDateWithinStartMonth,
        },
        {
          fieldName: 'Status',
          label: 'Status *',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EditOutsourcedUserFteWindowDescription.getStatusOptions(),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ModifiedDesc',
          label: 'Description of Change',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
  ];

  static getStatusOptions() {
    return [
      { label: 'Choose one...', value: '', disabled: true },
      { label: 'Open', value: 'Open' },
      { label: 'Confirmed', value: 'Confirmed' },
    ];
  }
}
